import axios from 'axios';
import {
  GET_MEDIA_DETAILS,
  GET_ALBUM_DETAILS,
  CLEAR_DETAILS,
} from '../constants';

export const clearDetails = () => ({
  type: CLEAR_DETAILS,
});

export const getMediaDetailsSuccess = response => ({
  type: GET_MEDIA_DETAILS,
  response,
});

export const getMediaDetails = id => dispatch => (
  axios.get(`/videos/movie/${id}`)
    .then((response) => {
      const data = {
        status: response.status,
        data: response.data.data,
      };
      return dispatch(getMediaDetailsSuccess(data));
    })
    .catch((error) => {
      const data = {
        status: 0,
        data: {},
      };
      if (error.response) {
        data.status = error.response.status;
      } else if (error.request) {
        data.status = 0;
      } else {
        data.status = 0;
      }
      dispatch(getMediaDetailsSuccess(data));
    })
);

export const getAlbumDetailsSuccess = response => ({
  type: GET_ALBUM_DETAILS,
  response,
});

export const getAlbumDetails = id => dispatch => (
  axios.get(`/videos/serial/${id}`)
    .then((response) => {
      const data = {
        status: response.status,
        data: response.data.data,
      };
      return dispatch(getAlbumDetailsSuccess(data));
    })
    .catch((error) => {
      const data = {
        status: 0,
        data: [],
      };
      if (error.response) {
        data.status = error.response.status;
      } else if (error.request) {
        data.status = 0;
      } else {
        data.status = 0;
      }
      dispatch(getAlbumDetailsSuccess(data));
    })
);
